import { bookingEngineService } from '@/libs/api/instances/booking-engine-instance';
import type { RequestOptions } from '@/libs/api/types';

/** Org whose coach directory the app searches. */
export const COACH_DIRECTORY_ORG_SLUG = 'us-kids-golf-org-dev';

/** Coach categories the "Find a nearby coach" step searches for. */
export const COACH_DIRECTORY_CATEGORIES = ['CERTIFIED COACH', 'PATHWAY COACH'];

/** Body for POST /rest/coachDirectory/search (radius mode). */
export type CoachDirectorySearchRequest = {
  orgSlug: string;
  coachCategory?: string[];
  includeFilters?: boolean;
  page?: number;
  pageSize?: number;
  mode?: 'radius';
  center: { lat: number; lng: number };
  radiusMiles: number;
  sortBy?: 'distance';
};

/** One coach result from the directory search (mirrors the response schema). */
export type CoachDirectoryResult = {
  facilityName?: string;
  address?: string;
  lat?: number;
  lng?: number;
  coach?: {
    id?: string;
    name?: string;
    displayName?: string;
    imageUrl?: string;
    category?: string;
    badges?: { badgeUrl?: string }[];
    awards?: { imageUrl?: string }[];
  };
};

export type CoachDirectorySearchResponse = {
  results?: CoachDirectoryResult[];
  total?: number;
  coachesCount?: number;
  filters?: unknown;
};

/** Path (baseURL comes from the booking-engine instance). */
const COACH_DIRECTORY_SEARCH_PATH = '/rest/coachDirectory/search';

/**
 * Searches the booking-engine coach directory by radius around a center point via the
 * public booking-engine axios instance (no auth).
 */
export async function searchCoachDirectory(
  body: CoachDirectorySearchRequest,
  options?: RequestOptions,
): Promise<CoachDirectorySearchResponse> {
  return bookingEngineService.post<CoachDirectorySearchResponse, CoachDirectorySearchRequest>(
    COACH_DIRECTORY_SEARCH_PATH,
    body,
    options,
  );
}
